import {
  useNavigationHandlers,
  useDynamicPolling,
  useGTM,
} from '@src/shared/hooks';

import { goToByError } from '@src/shared/utils';
import { useEffect } from 'react';
import {
  useSettingsState,
  useSelectedLoanSimulationState,
  useProposalState,
} from '@src/shared/hooks';
import { getProposal, setEtapa } from '@src/shared/zustand';
import { Proposal } from '@src/shared/models';
import { GTMEvents } from '@src/config/gtm';
import { Etapa } from '@src/shared/models/etapa';

export const useLoadingController = () => {
  const { proposal } = useProposalState();
  const { paymentPoolingIntervals } = useSettingsState();

  const { loanSimulation } = useSelectedLoanSimulationState();

  const navigation = useNavigationHandlers();
  const { trackEvent } = useGTM();

  useEffect(() => {
    setEtapa(Etapa.ENTRY_TICKET_LOADING);

    trackEvent(GTMEvents.SEND_EMAIL_VALIDATION, {
      proposal_id: proposal.proposalId,
      qtd_parcelas: loanSimulation?.schedule.length,
      valor_parcelas: loanSimulation?.schedule[0].payment,
      valor_total: loanSimulation?.totalAmountOwedWithDownPayment,
      valor_entrada: loanSimulation?.downPayment,
      valor_viagem: loanSimulation?.totalPriceOfFlightTicket,
    });
  }, []);

  // Configuração do pooling dinâmico
  const { startPolling, stopPolling } = useDynamicPolling<Proposal>({
    intervals: paymentPoolingIntervals,
    pollFunction: async () => {
      return new Promise<Proposal>((resolve, reject) => {
        getProposal(proposal.proposalId, (error, proposalData) => {
          if (error) {
            reject(error);
          } else {
            resolve(proposalData!);
          }
        });
      });
    },
    shouldContinue: (result) => {
      // Continua o pooling se não há pagamentos
      return !result.payments || result.payments.length === 0;
    },
    onSuccess: () => {
      // Sucesso: encontrou pagamentos, navega para ticket
      navigation.toTicket();
    },
    onError: (error) => {
      // Erro: navega para tela de erro
      goToByError(error as any, navigation);
    },
    onTimeout: () => {
      // Timeout: esgotou todos os intervalos, navega para erro
      navigation.toError();
    },
  });

  // Cleanup: para o pooling quando o componente for desmontado
  useEffect(() => {
    startPolling();

    return () => {
      stopPolling();
    };
  }, []);
};
